import styled from 'styled-components';

import COLOR from '../../../utils/colors.constants';

const Title = styled.h2`
  text-align: center;
  color: ${COLOR.AZUL};
  font-weight: bold;

`;


export default Title;
